module.exports = __webpack_public_path__ + "img/inge-v9-char-5.e3251599.png";